<template>
  <a-row :gutter="24" type="flex">

    <!-- Projects Table Column -->
    <a-col :span="24" class="mb-24">

      <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{padding: 0}">
        <template #title>
          <a-row type="flex" align="middle">
            <a-col :span="24" :md="12" class="top-left-header">
              <h5 class="font-semibold m-0">
                Gratification List
                <a-spin v-if="confirmLoading"/>
              </h5>
            </a-col>
          </a-row>
        </template>
        <a-table :columns="columnData"
                 :data-source="gratificationList"
                 :pagination="false">

          <template slot="name" slot-scope="text">
            <a>{{ text }}</a>
          </template>

          <template slot="updateBtn" slot-scope="row">
            <div>
              <a-button type="link" :data-id="row.key">
                <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"
                     @click="gratificationDetails(row.details)">
                  <path
                      d="M22 24h-20v-24h14l6 6v18zm-7-23h-12v22h18v-16h-6v-6zm3 15v1h-12v-1h12zm0-3v1h-12v-1h12zm0-3v1h-12v-1h12zm-2-4h4.586l-4.586-4.586v4.586z"/>
                </svg>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                     @click="updateRemarkModal(row.details.id)" v-if="! row.details.price_status">
                  <path class="fill-gray-7"
                        d="M13.5858 3.58579C14.3668 2.80474 15.6332 2.80474 16.4142 3.58579C17.1953 4.36683 17.1953 5.63316 16.4142 6.41421L15.6213 7.20711L12.7929 4.37868L13.5858 3.58579Z"/>
                  <path class="fill-gray-7"
                        d="M11.3787 5.79289L3 14.1716V17H5.82842L14.2071 8.62132L11.3787 5.79289Z"/>
                </svg>
              </a-button>
            </div>
          </template>
        </a-table>
      </a-card>

    </a-col>
    <!-- / Projects Table Column -->

    <!--    Gratification Details Modal-->
    <a-modal
        v-model:detailsModal="detailsModal"
        title="Score Manipulate"
        v-if="Object.keys(detailsData).length"
        @ok="closeDetailsModal"
    >
      <div class="user-prize-details">
        <div><span class="font-bold">User Name:</span> {{ detailsData.user.name }}</div>
        <div><span class="font-bold">User Phone:</span> {{ detailsData.user.phone }}</div>
        <div><span class="font-bold">User Position:</span> {{ detailsData.position_name }}</div>
        <div><span class="font-bold">Description:</span> {{ detailsData.remark_description }}</div>
        <div><span class="font-bold">Status:</span> {{ detailsData.price_status ? 'Done' : 'Not Finish' }}</div>
      </div>
    </a-modal>


    <!--    Update gratification-->
    <a-modal
        v-model:updateModal="updateModal"
        title="Score Manipulate"
        :confirm-loading="confirmLoading"
        @ok="closeUpdateModal"
    >
      <div class="new-upload-data">
        <div>
          <label>Description</label>
          <a-textarea v-model="remarkDescription"/>
        </div>
        <div v-if="errorMsg.length" class="ant-btn-danger mt-5">{{ errorMsg }}</div>
      </div>
    </a-modal>
  </a-row>
</template>

<script>
import {sendRequest} from '@/http/axios.method';

const COLUMN_DATA = [
  {
    title: 'User Name',
    dataIndex: 'user_name',
    width: 200,
  },
  {
    title: 'Phone',
    dataIndex: 'phone',
    width: 200,
  },
  {
    title: 'Position',
    dataIndex: 'position',
    class: 'font-semibold text-muted',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    class: 'font-semibold text-muted',
  },
  {
    title: 'Action',
    scopedSlots: {customRender: 'updateBtn'},
    width: 200,
  },
];
export default {
  name: "Gratification",
  data() {
    return {
      config: {
        'Authorization': 'Bearer ' + this.$store.state.authUser.token
      },
      columnData: COLUMN_DATA,
      gratificationList: [],
      tournamentId: this.$route.query.tournament_id,
      confirmLoading: false,
      detailsModal: false,
      detailsData: [],
      errorMsg: false,
      updateModal: false,
      gratificationId: '',
      remarkDescription: '',
    }
  },
  created() {
    this.getGratificationList();
  },
  methods: {
    getGratificationList() {
      this.confirmLoading = true;
      let data = {
        tournament_id: this.tournamentId,
      }
      sendRequest('get', 'admin/leaderboard-gratification-list', data, this.config)
          .then(response => {
            this.confirmLoading = false;
            if (response.success) {
              let data = response.data.gratification_list
              this.gratificationList = data.map(function (content, label) {
                return {
                  key: label + 1,
                  id: content.id,
                  tournament_id: content.tournament_id,
                  user_name: content.user.name,
                  phone: content.user.phone,
                  position: content.position_name,
                  remark_description: content.remark_description,
                  status: content.price_status ? 'Done' : 'Not finish',
                  details: content
                };
              });
            } else {
              if (response.status_code === 401) {
                this.$store.dispatch('logout');
                this.$router.push('/login');
              }
            }
          })
          .catch(() => {
            this.confirmLoading = false;
          })
          .finally(() => {
            this.confirmLoading = false;
          })
    },
    gratificationDetails(details) {
      this.detailsData = details;
      this.detailsModal = true;
    },
    closeDetailsModal() {
      this.detailsData = [];
      this.detailsModal = false;
    },
    updateRemarkModal(gratification_id) {
      this.gratificationId = gratification_id;
      this.updateModal = true;
    },
    closeUpdateModal() {
      this.errorMsg = false;
      if (this.validateRemark()) {
        let data = {
          tournament_id: this.tournamentId,
          gratification_id: this.gratificationId,
          remark_description: this.remarkDescription
        }

        sendRequest('post', 'admin/leaderboard-gratification-update', data, this.config)
            .then(response => {
              this.confirmLoading = false;
              if (response.success) {
                this.gratificationId = '';
                this.remarkDescription = '';
                window.location.reload()
              } else {
                if (response.status_code === 401) {
                  this.$store.dispatch('logout');
                  this.$router.push('/login');
                }
              }
            })
            .catch(() => {
              this.confirmLoading = false;
            })
            .finally(() => {
              this.confirmLoading = false;
            })
      }

    },

    validateRemark() {
      if (this.remarkDescription.length === 0) {
        this.errorMsg = 'Please provide remark description';
        return false;
      }

      return true;
    }
  }
}
</script>

<style scoped>

</style>
